var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.08 49.0916C94.08 45.688 93.7745 42.4153 93.2073 39.2734H48V57.8407H73.8327C72.72 63.8407 69.3382 68.9243 64.2545 72.328V84.3716H79.7673C88.8436 76.0153 94.08 63.7098 94.08 49.0916Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.999 95.9996C60.959 95.9996 71.8245 91.7014 79.7663 84.3705L64.2536 72.3269C59.9554 75.2069 54.4572 76.9087 47.999 76.9087C35.4972 76.9087 24.9154 68.4651 21.1409 57.1196H5.10449V69.556C13.0027 85.2433 29.2354 95.9996 47.999 95.9996Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1418 57.1192C20.1818 54.2392 19.6364 51.1629 19.6364 47.9992C19.6364 44.8356 20.1818 41.7592 21.1418 38.8792V26.4429H5.10545C1.85455 32.9229 0 40.2538 0 47.9992C0 55.7447 1.85455 63.0756 5.10545 69.5556L21.1418 57.1192Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.999 19.0909C55.0463 19.0909 61.3736 21.5127 66.3481 26.2691L80.1154 12.5018C71.8027 4.75636 60.9372 0 47.999 0C29.2354 0 13.0027 10.7564 5.10449 26.4436L21.1409 38.88C24.9154 27.5345 35.4972 19.0909 47.999 19.0909Z",
    fill: "#EA4335"
  })));
};
export default SvgGoogle;